import EventDetailsPage from './EventDetailsPage';

export default EventDetailsPage;
